const NAMESPACE = 'product-description-expand';

(async () => {
    const {
        showElement,
    } = await import(window.theme.modules.utils);

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define(
        NAMESPACE,
        class extends baseComponent.default {

            elements = {
                content: '[data-content]',
                link: '[data-expand-link]'
            };

            expandThreshold = 100;

            render() {
                const contentHeight = this.$content.offsetHeight;

                // Only show Read More if content is taller than the limit
                if (contentHeight > this.expandThreshold * 1.25) {

                    // Set collapsed height
                    this.style.setProperty(
                        `--${NAMESPACE}-height`,
                        `${this.expandThreshold}px`
                    );

                    // Show the expand/collapse link
                    showElement(this.$link);

                    // Initial button text with down arrow
                    this.$link.innerHTML = `
                        Read More
                        <svg class="#icon">
    <use href="#svg-icon-chevron-down"></use>
</svg>
                    `;

                    // Handle click
                    this.$link.addEventListener('click', (event) => {
                        event.preventDefault();

                        // Toggle expanded state
                        this.toggleAttribute('expanded');

                        // Change text and arrow direction
                        if (this.hasAttribute('expanded')) {
                            this.$link.innerHTML = `
                                Read Less
                                <svg class="#icon">
                                    <use href="#svg-icon-chevron-down"></use>
                                </svg>
                                                            `;
                        } else {
                            this.$link.innerHTML = `
                                Read More
                                <svg class="#icon">
    <use href="#svg-icon-chevron-down"></use>
</svg>
                            `;
                        }
                    });
                }
            }
        }
    );
})();